// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__raZNn","title":"Info_title__J1tVr","selects":"Info_selects__ys0LU","requiredAsterisk":"Info_requiredAsterisk__2kEWV"};